import { h, Component, Element, Event, EventEmitter, Prop, Listen }
  from '@stencil/core';


@Component({
  tag: 'tip-table-filters'
})
export class TableFilters {
  updateEventEnabled: boolean = true

  @Element() el: HTMLElement;

  @Event() glFiltersUpdate: EventEmitter;

  @Prop() selectionFilterOptions: any;
  @Prop() keywordSearch: boolean = true;

  clearSelection() {
    this.updateEventEnabled = false;
    let selects = Array.from(this.el.querySelectorAll('tip-table-filter'));
    selects.map(select => select.value = null)
    let searchBox = this.el.querySelector('tip-search-box');
    searchBox.value = null;
    this.glFiltersUpdate.emit({
      selectionFilters: []});
    this.updateEventEnabled = true;
  }

  @Listen('glFilterChanged')
  handleChange() {
    if (this.updateEventEnabled) {
      let filters = Array.from(this.el.querySelectorAll('tip-table-filter'))
      let selectionFilters = []
      for (let filter of filters) {
        if (filter.value != null) {
          selectionFilters.push(filter.selectionFilter);
        }
      }
      let keywordFilter = this.el.querySelector('tip-search-box');
      if (keywordFilter.value != null) {
        selectionFilters.push(keywordFilter.keywordFilter)
      }

      this.glFiltersUpdate.emit({
        selectionFilters: selectionFilters});
    }
  }

  render() {
    return (
      <ion-list>
        <slot name='start' />
        <slot />
        <slot name='end' />
        <ion-button expand='full'
          onClick={() => this.clearSelection()}>Reset Filters</ion-button>
      </ion-list>
    );
  }
}
